export default __webpack_public_path__ + "static/media/glass_e.235c9bfe.svg";